import { forwardRef, useCallback } from 'react';
import { RadioGroupProps } from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import RadioCheckedIcon from 'components/icons/RadioCheckedIcon';
import RadioIcon from 'components/icons/RadioIcon';

import styles from './RadioButton.module.scss';
import { Body } from 'components/text';

export type RadioOptionType = {
  value: string;
  label: string;
};

interface IRadioGroup extends RadioGroupProps {
  name: string;
  options: RadioOptionType[];
  onRadioButtonClick: (name: string, value: string) => void;
  errorMsg?: string | undefined;
  className?: string;
}

const RadioButton = forwardRef<HTMLDivElement, IRadioGroup>(
  function RadioButtonWithRef(
    { name, value, options, onRadioButtonClick, errorMsg, className },
    ref
  ) {
    const handleChange = useCallback(
      (value: string) => {
        onRadioButtonClick(name, value);
      },
      [name, onRadioButtonClick]
    );

    return (
      <div className={className}>
        <RadioGroup
          ref={ref}
          aria-labelledby="radio-buttons-group-label"
          name="radio-buttons-group"
          value={value ?? ''}
          onChange={e => handleChange(e.target.value)}
          className={styles.radioContainer}
        >
          {options.map(option => (
            <FormControlLabel
              key={option.value}
              className={`${styles.radioButton} ${errorMsg && styles.error}`}
              value={option.value}
              control={
                <Radio
                  icon={<RadioIcon />}
                  checkedIcon={<RadioCheckedIcon />}
                />
              }
              label={option.label}
            />
          ))}
        </RadioGroup>
        {errorMsg && <Body color="forms-red">{errorMsg}</Body>}
      </div>
    );
  }
);

export default RadioButton;
